import { mutations } from './mutations';
var state = {
    email: '',
};
export var auth = {
    namespaced: true,
    state: state,
    mutations: mutations,
};
